/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { SimButton } from 'components/SimButton';

const mock = [
	{
		image: 'https://assets.maccarianagency.com/backgrounds/img13.jpg',
		description:
			'Diagnostics ResourcesLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		title: 'Diagnostics Resource Library',
		author: {
			name: 'Expert: Dr. Chen'
		},
		date: '04 Jan 2023'
	},
	{
		image: 'https://assets.maccarianagency.com/backgrounds/img14.jpg',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		title: 'Therapeutics Resource Library',
		author: {
			name: 'Expert: Dr. Patil'
		},
		date: '14 Jan 2023'
	},
	{
		image: 'https://assets.maccarianagency.com/backgrounds/img15.jpg',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		title: 'ParentEd Resource Library',
		author: {
			name: 'Expert: Dr. Page'
		},
		date: '03 Dec 2022'
	},
	{
		image: 'https://assets.maccarianagency.com/backgrounds/img16.jpg',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		title: 'ParentEd Resource Library',
		author: {
			name: 'Expert: Dr. Page'
		},
		date: '03 Dec 2022'
	},
	{
		image: 'https://assets.maccarianagency.com/backgrounds/img17.jpg',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		title: 'Neuro Developmental Disorders',
		author: {
			name: 'Expert: Dr. Patil'
		},
		date: '23 Dec 2022'
	}
];

const SidebarArticles = () => {
	const theme = useTheme();
	return (
		<Box component={Card} variant={'outlined'} padding={2}>
			<Typography
				variant='h6'
				data-aos={'fade-up'}
				sx={{
					fontWeight: 700,
					marginBottom: 2
				}}>
				Upcoming Resource updates
			</Typography>
			<Grid container spacing={2}>
				{mock.map((item, i) => (
					<Grid key={i} item xs={12}>
						<Box
							component={Card}
							width={1}
							height={1}
							boxShadow={0}
							borderRadius={0}
							display={'flex'}
							flexDirection={{ xs: 'column', md: 'row' }}
							sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}>
							<Box
								sx={{
									width: { xs: 1, md: '50%' }
								}}>
								<Box
									component={'img'}
									loading='lazy'
									height={1}
									width={1}
									src={item.image}
									alt='...'
									sx={{
										objectFit: 'cover',
										maxHeight: 120,
										borderRadius: 2,
										filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none'
									}}
								/>
							</Box>
							<CardContent sx={{ padding: 1, '&:last-child': { paddingBottom: 1 } }}>
								<Typography fontWeight={700}>{item.title}</Typography>
								<Box marginY={1 / 4}>
									<Typography variant={'caption'} color={'text.secondary'} component={'i'}>
										{item.author.name} - {item.date}
									</Typography>
								</Box>
								<SimButton size={'small'}>Read More</SimButton>
							</CardContent>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default SidebarArticles;
